import { motion } from "framer-motion";

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="w-full bg-white border-t border-warm-200">
      <div className="max-w-[1000px] mx-auto px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <img
              src="https://static.readdy.ai/image/3c1a6ae95f0e375c290cace2b2bb289a/ebd5889aa717ac1188561408790e0178.png"
              alt="BAR bebé"
              className="h-10 w-auto object-contain"
            />
            <p className="text-xs font-sans text-warm-500">
              &copy; 2024 BAR bebé All Rights Reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
            {[
              { label: "CONCEPT", href: "#concept" },
              { label: "SYSTEM", href: "#system" },
              { label: "MENU", href: "#menu" },
              { label: "Q&A", href: "#qa" },
              { label: "ACCESS", href: "#access" },
            ].map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(item.href);
                }}
                className="text-xs font-sans tracking-extra-wide text-warm-600 hover:text-amber-500 transition-colors duration-300 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Instagram CTA */}
          <a
            href="https://www.instagram.com/barbebe_0515?igsh=eTQyZXByYmJoYndh"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-5 py-3 rounded-xl bg-gradient-to-r from-pink-500 to-orange-400 text-white font-sans font-medium text-sm hover:opacity-90 transition-opacity duration-300"
          >
            <i className="ri-instagram-line text-lg" />
            Instagram をフォロー
          </a>
        </div>
      </div>
    </footer>
  );
}